// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const closeButtonWrapper = "OverlayMobile__closeButtonWrapper__Ywt9S";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const noPadding = "OverlayMobile__noPadding__xeF1v";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const wrapper = "OverlayMobile__wrapper__xWGFd";